module.exports = __webpack_public_path__ + "img/about-03.feee3a1a.jpg";